// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  z-index: 101 !important;
}

.dt-picker ::ng-deep ngx-daterangepicker-material .md-drppicker.double {
  min-width: 640px !important;
}

.btn-calendar {
  cursor: pointer;
  font-weight: 800;
  color: rgba(var(--primary-rgb), 0.8);
}
.btn-calendar:hover {
  color: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/controls/datetime-picker/datetime-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAKY;EACI,2BAAA;AAFhB;;AAQA;EACI,eAAA;EACA,gBAAA;EACA,oCAAA;AALJ;AAMI;EACI,qBAAA;AAJR","sourcesContent":[":host {\n    z-index: 101 !important;\n}\n\n.dt-picker {\n    ::ng-deep ngx-daterangepicker-material {\n        & {\n            .md-drppicker.double {\n                min-width: 640px !important;\n            }\n        }\n    }\n}\n\n.btn-calendar {\n    cursor: pointer;\n    font-weight: 800;\n    color: rgba(var(--primary-rgb), 0.8);\n    &:hover {\n        color: var(--primary);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
